<template>
    <div class="mobileapp">
        <h2 class="font-weight-bold">Find top developer for Mobile App</h2>
            <button class="btn-outline-kovatek text-uppercase mt-2">get started</button>
            <div class="wide mt-5">
            <!-- <carousel-3d :width="320" :height="380">
                <slide :index="0" class="bg-white">
                        <TopRatedDev name="Mike. P" image="staff-1.jpg" specialization="Back-end Developer" experienced="true" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" />

                </slide>
                <slide :index="1" class="bg-white">
                        <TopRatedDev name="Johnson. K" image="person_2.jpg" specialization="Web Developer" experienced="true" charge="25" location="Lagos, Nigeria" :skills="['Django', 'Flask', 'Rails']" />

                </slide>
                <slide :index="2" class="bg-white">
                        <TopRatedDev name="Adara. W" image="person_4.jpg" specialization="Front-end Developer" experienced="true" charge="18" location="Ogun, Nigeria" :skills="['Reactjs', 'Nodejs', 'Go']" />

                </slide>
                <slide :index="3" class="bg-white">
                        <TopRatedDev name="Idirs. A" image="staff-4.jpg" specialization="Full Stack Developer" experienced="true" charge="32" location="Ibadan, Nigeria" :skills="['PHP', 'Python', 'Java']" />

                </slide>
                 <slide :index="4" class="bg-white">
                        <TopRatedDev name="Mike. P" image="staff-1.jpg" specialization="Back-end Developer" experienced="true" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" />
                    
                </slide>
                <slide :index="5" class="bg-white">
                        <TopRatedDev name="Johnson. K" image="person_2.jpg" specialization="Web Developer" experienced="true" charge="25" location="Lagos, Nigeria" :skills="['Django', 'Flask', 'Rails']" />
                </slide>
            </carousel-3d> -->
            </div>

            <!-- <div class="">
                <vueper-slides class="no-shadow" :arrows="true" :visible-slides="3" :slide-ratio="1/4" :dragging-distance="70">
                    <vueper-slide class="bg-dark" :key="1" :title="1">
                        <TopRatedDev name="Mike. P" image="staff-1.jpg" specialization="Back-end Developer" experienced="true" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" />
                    </vueper-slide>
                    <vueper-slide class="bg-primary" :key="2" :title="1">
                        <TopRatedDev name="Mike. P" image="staff-1.jpg" specialization="Back-end Developer" experienced="true" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" />
                    </vueper-slide>
                    <vueper-slide class="bg-success" :key="3" :title="1">
                        <TopRatedDev name="Mike. P" image="staff-1.jpg" specialization="Back-end Developer" experienced="true" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" />
                    </vueper-slide>
                    <vueper-slide class="bg-dark" :key="4" :title="1">
                        <TopRatedDev name="Mike. P" image="staff-1.jpg" specialization="Back-end Developer" experienced="true" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" />
                    </vueper-slide>
                    <vueper-slide :key="5" :title="1">
                        <TopRatedDev name="Mike. P" image="staff-1.jpg" specialization="Back-end Developer" experienced="true" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" />
                    </vueper-slide>
                </vueper-slides>
            </div> -->
            <div class="top-devs m-auto">
        <div class="px-sm-4 px-lg-4 mx-auto my-5 pb-4">
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-3 my-3">
                        <TopRatedDev name="Mike. P" image="mike.png" specialization="Back-end Developer" charge="30" location="Lagos, Nigeria" :skills="['PHP', 'Nodejs','Go']" level="senior" rating="9.1" reviews="43"/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 my-3">
                        <TopRatedDev name="Johnson. K" image="developer-1.png" specialization="Web Developer" charge="25" location="Lagos, Nigeria" :skills="['Django', 'Flask', 'Rails']" level="intermediate" rating="9.5" reviews="56"/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 my-3">
                        <TopRatedDev name="Adara. W" image="developer-2.jpeg" specialization="Front-end Developer" charge="18" location="Ogun, Nigeria" :skills="['Reactjs', 'Nodejs', 'Go']" level="intermediate" rating="8.7" reviews="73"/>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-3 my-3">
                        <TopRatedDev name="Idirs. A" image="developer-3.png" specialization="Full Stack Developer" charge="32" location="Ibadan, Nigeria" :skills="['PHP', 'Python', 'Java']" level="senior" rating="9.0" reviews="20"/>
                    </div>

                </div>
            </div>
    </div>

            <HowItWorks />
            <Footer/>
    </div>
</template>

<script>

import TopRatedDev from '@/components/TopRatedDev.vue';
import Footer from '@/components/Footer.vue';
import HowItWorks from '@/components/HowItWorks.vue';
// import { Carousel3d, Slide } from 'vue-carousel-3d';
// import { VueperSlides, VueperSlide } from 'vueperslides';
// import 'vueperslides/dist/vueperslides.css';
// import JQuery from 'jquery'
// let $ = JQuery

export default {
    name: 'mobileapp',
    components: {
        TopRatedDev, Footer, HowItWorks, 
        // Carousel3d, Slide, VueperSlides, VueperSlide
    },
    mounted:{
    }
}

// $('#recipeCarousel').carousel({
//   interval: 10000
// })

// $('.carousel .carousel-item').each(function(){
//     var next = $(this).next();
//     if (!next.length) {
//     next = $(this).siblings(':first');
//     }
//     next.children(':first-child').clone().appendTo($(this));
    
//     if (next.next().length>0) {
//     next.next().children(':first-child').clone().appendTo($(this));
//     }
//     else {
//       $(this).siblings(':first').children(':first-child').clone().appendTo($(this));
//     }
// });


</script>

<style scoped>
.wide{
    width: 100%;
}
.cont-w{
    width: 320px;
    height:auto;
}

.btn-outline-kovatek{
  background-color: #20409a;
  border: solid 1px #20409a;
  outline: 0;
  color: #fff;
  width: 200px;
  height: 50px;
  transition: .25s;
  border-radius: 5px;
  font-size: 16px;
}
.btn-outline-kovatek:hover{
  background-color: #fff;
  border: solid 1px #20409a;
  color: #20409a;
}


</style>